import { CustomPageTitle, ListItem, ThematicsIconProvider } from '@components';
import { Container, Icon, Typography } from '@design-system';
import React from 'react';
import { FaGraduationCap } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useFormationTalkListPageVM } from './useFormationTalkListPageVM';

export const FormationTalkListPage: React.FC = () => {
    const { isLoading, formations, category } = useFormationTalkListPageVM();

    const navigate = useNavigate();

    return (
        <Container className="formation-talk-list-page" height="fill">
            {category && (
                <CustomPageTitle>
                    <Typography intrinsic="h3" iconColor="blue" icon={<FaGraduationCap />} iconFilled iconSize={20}>
                        {category.title}
                    </Typography>
                </CustomPageTitle>
            )}

            <Typography intrinsic="h2" defaultSpacing className="mb-medium-spacing-forced">
                Les formations
            </Typography>

            {isLoading ? (
                <p>Chargement des formations...</p>
            ) : (
                <>
                    {category && (
                        <div>
                            <ListItem
                                key={category.id}
                                title={category.title}
                                icon={
                                    <Icon icon={<ThematicsIconProvider icon={category.icon} />} size={24} color="green" variant="plain" />
                                }
                                onClick={() => {
                                    // Nothing to do
                                }}
                                type="dropdown"
                                dropdownItems={formations.map((formation) => ({
                                    id: formation.id,
                                    label: formation.title,
                                    onClick: () => navigate(`/sante-securite/formations/list/${category.id}/files/${formation.id}`)
                                }))}
                            />
                        </div>
                    )}
                </>
            )}
        </Container>
    );
};
